export default "__VITE_ASSET__CrE5w3k5__"